import { createContext, useContext, type ReactNode } from 'react'
import type { FormKind } from '#app/utils/application-form/catalog'
import {
	type FormConfigV1,
	defaultFormConfig,
	fieldEnabled,
	prebuiltQuestionEnabled,
	sectionEnabled,
} from '#app/utils/application-form/config'

const FormConfigContext = createContext<FormConfigV1 | null>(null)

export function FormConfigProvider({
	config,
	kind,
	children,
}: {
	config?: FormConfigV1 | null
	kind: FormKind
	children: ReactNode
}) {
	const value = config ?? defaultFormConfig(kind)
	return (
		<FormConfigContext.Provider value={value}>
			{children}
		</FormConfigContext.Provider>
	)
}

export function useFormConfig(): FormConfigV1 {
	const value = useContext(FormConfigContext)
	return value ?? defaultFormConfig('standard')
}

export function useSectionEnabled(
	key: Parameters<typeof sectionEnabled>[1],
): boolean {
	return sectionEnabled(useFormConfig(), key)
}

export function useFieldEnabled(
	section: Parameters<typeof fieldEnabled>[1],
	field: string,
): boolean {
	return fieldEnabled(useFormConfig(), section, field)
}

export function usePrebuiltQuestionEnabled(
	block: 'rental_questions' | 'employment_questions',
	key: string,
): boolean {
	return prebuiltQuestionEnabled(useFormConfig(), block, key)
}
